import { render, staticRenderFns } from "./tableAnalytics.vue?vue&type=template&id=36359fae&scoped=true"
import script from "./tableAnalytics.vue?vue&type=script&lang=js"
export * from "./tableAnalytics.vue?vue&type=script&lang=js"
import style0 from "./tableAnalytics.vue?vue&type=style&index=0&id=36359fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36359fae",
  null
  
)

export default component.exports